import React, { useEffect, useState } from "react";

import * as myConstList from "../Common/BaseUrl";
import DocumentMeta from "react-document-meta";
import axios from "axios";
import Footer from "../Common/Footer";
import Moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ProductName } from "../Common/ProductName";
import Nav from "../Common/Nav";
import { useParams } from "react-router-dom";
const baseUrl = myConstList.baseUrl;


const TradingDetails = () => {
  const { id } = useParams();

  const [heading, setHeading] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [createdAt, setCreatedAt] = useState("");

  useEffect(() => {
    getData();
    return () => {};
  }, []);

  const getData = () => {

    console.log("call or not")
    axios
      .get(baseUrl + `/tradeideas/getbyid/${id}`)
      .then((res) => {
        var resp = res.data.data;

        console.log(resp)
        setHeading(resp.heading);
        setTitle(resp.subtitle);
        setDescription(resp.description);
        setImage(resp.image);
        dateHtml(resp.created_at);
      });
  };

  const meta = {
    title: `Trading Idea | ${ProductName}  Exchange`,
    description: `Login on ${ProductName}  Exchange now and start trading! Invite your friends to ${ProductName}  Exchange.`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: `${ProductName}  Exchange , Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
      },
    },
  };

  const dateHtml = (createdAt) => {
    // Parse the input date using moment


    // Format the date in the desired output format (DD/MM/YYYY)

    setCreatedAt(createdAt);
  };

  return (
    <DocumentMeta {...meta}>
      <div>
        <Nav graphColor={""} />
        <div className="blog-detail more-blog-main">
          <div className="container">
            <div className="blog-main-outer">
              <div className="img-outer">
                <img
                  src={baseUrl + "/static/" + image}
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="content-outer">
                <h2>
                  {heading}
                  <small className="blog-date">{createdAt}</small>
                </h2>

                <h4>{title}</h4>

                <p>{description}</p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </DocumentMeta>
  );
};

export default TradingDetails;
